import { ColDef, ValueFormatterParams } from '@ag-grid-community/core'
import { NfColumnTypes, NfGridOptions } from '@northfork/ag-grid'
import { formatNumberValue } from '@northfork/basics'

/** NumberValueFormatter for displaying number values to eight decimal places */
export const milRateNumberFormatter = (params: ValueFormatterParams) => {
  return formatNumberValue(params.value, '1.8-8') ?? ''
}

export const HsMilRateColDef: ColDef = {
  ...(NfGridOptions.columnTypes?.[NfColumnTypes.Number] ?? {}),
  valueFormatter: milRateNumberFormatter,
}
